import { observable } from "@legendapp/state";
import { FilterMatchMode } from "primereact/api";
import ReportsConstants from "reports/utils/ReportsConstants";

const { ALL } = ReportsConstants;
const PAGE_SIZE = 100;

const tableState = Object.freeze({
  filters: {
    reportName: { value: "", matchMode: FilterMatchMode.EQUALS },
    status: { value: ALL, matchMode: FilterMatchMode.EQUALS },
    reportType: { value: ALL, matchMode: FilterMatchMode.EQUALS },
  },
  first: 0,
  page: 0,
  rows: PAGE_SIZE,
  sortOrder: "name,report",
  totalRecords: 0,
  updatedEntities: [],
});

const DataExportListStore$ = observable({
  reset: () => {
    DataExportListStore$.assign({
      selection: null,
      tableData: [],
      tableState: structuredClone(tableState),
      totalRecords: 0,
    });
  },
  selection: null,
  sidePanel: {
    action: "",
    data: null,
    visible: false,
    width: "70rem",
  },
  tableData: [],
  tableState: structuredClone(tableState),
  totalRecords: 0,
});

export default DataExportListStore$;
